/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRectXIcon16Solid = forwardRef('CommentRectXIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 4.5A2.5 2.5 0 0 1 3.5 2h9A2.5 2.5 0 0 1 15 4.5v6a2.5 2.5 0 0 1-2.5 2.5H8.25l-3.695 2.463A1 1 0 0 1 3 14.633V12.95a2.5 2.5 0 0 1-2-2.45v-6Zm9.74 1.49a.875.875 0 0 0-1.237-1.237L8 6.255 6.497 4.753A.875.875 0 1 0 5.26 5.99l1.503 1.503L5.26 8.995a.875.875 0 0 0 1.237 1.238L8 8.73l1.503 1.503a.875.875 0 1 0 1.237-1.238L9.237 7.493 10.74 5.99Z" })));
});
